import Vue from 'vue'
//import * as firebase from 'firebase'
import firebase from 'firebase/app';
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore'
// import 'firebase/messaging'
// import 'firebase/functions'
import { store } from '../store'

new Vue({
  firebase,
  store,
  created() {
    //initialize
    // Your web app's Firebase configuration
    var firebaseConfig = {
      apiKey: "AIzaSyBUpZPn-NrRwY4T5gN7FUaOdQZXwnbiftw",
      authDomain: "teresian-sister.firebaseapp.com",
      databaseURL: "https://teresian-sister.firebaseio.com",
      projectId: "teresian-sister",
      storageBucket: "teresian-sister.appspot.com",
      messagingSenderId: "267354768182",
      appId: "1:267354768182:web:c70308cd2baeb0a675e997",
      measurementId: "G-R9299HDNQQ"
    };
    firebase.initializeApp(firebaseConfig) 
    //----------- LOGIN USER-----------------
    store.dispatch('setLoading', true)
    store.dispatch('setProcesses', { 
      name: 'logging'
    })
    firebase.auth().onAuthStateChanged(user => {
      store.dispatch('setUser', user)
      store.dispatch('setProcesses', {
        action: 'remove',
        value: 'logging'
      }) 
      if (user) {
        store.dispatch('fi_getOn_Message')
        store.dispatch('fi_getOn_Visiters')
      }
    }) 
    store.dispatch('fi_getOn_Services')
    store.dispatch('fi_getOn_Events')
    store.dispatch('fi_getOn_EventTypes')
    store.dispatch('fi_getOn_News')
    store.dispatch('fi_getOn_Sisters') 
    store.dispatch('fi_getOn_GalleryItem') 
    store.dispatch('fi_getOn_Communities') 
  },
})
